/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDownloadArchive
 */
export interface CreateDownloadArchive {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDownloadArchive
     */
    paths: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDownloadArchive
     */
    fileIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateDownloadArchive
     */
    bundleIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDownloadArchive
     */
    proxy?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDownloadArchive
     */
    forRoot?: number;
}

export function CreateDownloadArchiveFromJSON(json: any): CreateDownloadArchive {
    return CreateDownloadArchiveFromJSONTyped(json, false);
}

export function CreateDownloadArchiveFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDownloadArchive {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paths': json['paths'],
        'fileIds': !exists(json, 'file_ids') ? undefined : json['file_ids'],
        'bundleIds': !exists(json, 'bundle_ids') ? undefined : json['bundle_ids'],
        'proxy': !exists(json, 'proxy') ? undefined : json['proxy'],
        'forRoot': !exists(json, 'for_root') ? undefined : json['for_root'],
    };
}

export function CreateDownloadArchiveToJSON(value?: CreateDownloadArchive | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paths': value.paths,
        'file_ids': value.fileIds,
        'bundle_ids': value.bundleIds,
        'proxy': value.proxy,
        'for_root': value.forRoot,
    };
}


